import { PropsWithChildren } from "react"
import { Outlet } from "react-router-dom"
import { Platforms } from "utils/constants"

import { AuthManager } from "./AuthManager"

export const PrivateRoutes = ({
  children,
  platform = Platforms.student,
}: PropsWithChildren<{ platform?: Platforms }>) => {
  const auth = AuthManager.getPlatformAuth(platform)

  if (!auth) {
    AuthManager.redirectToLogin(platform)
    return null
  }

  return children ?? <Outlet />
}
